import { microserviceDocReviewAPI } from "./microserviceDocReviewAPI";

export const docReview = microserviceDocReviewAPI.injectEndpoints({
    endpoints: (builder) => ({
        saveRemediationFiles: builder.mutation({
            query: (data) => ({
                url: `/RegisterRequest`,
                method: "POST",
                body: data,
            }),
            extraOptions: { maxRetries: 0 },
        }),
        validateDocument: builder.mutation({
            query: (data) => ({
                url: `/ValidateDocument`,
                method: "POST",
                body: data,
            }),
            extraOptions: { maxRetries: 0 },
        }),
        consultDocuments: builder.mutation({
            query: (data) => ({
                url: `/ConsultDocuments`,
                method: "GET",
                headers: {
                    "externalRequestId": data.externalRequestId,
                    "documentTypeList": data.documentTypeList
                },
            }),
            extraOptions: { maxRetries: 0 },
        }),
        getReviewCurrentStatus: builder.mutation({
            query: (data) => ({
                url: `/getReviewCurrentStatus`,
                method: "GET",
                headers: {
                    "externalRequestId": data.externalRequestId,
                },
            }),
            extraOptions: { maxRetries: 0 },
        }),
        dnioptimization: builder.mutation({
            query: (data) => ({
                url: `/dnioptimization`,
                method: "POST",
                body: data,
            }),
            extraOptions: { maxRetries: 0 },
        }),
        rutoptimization: builder.mutation({
            query: (data) => ({
                url: `/rutoptimization`,
                method: "POST",
                body: data,
            }),
            extraOptions: { maxRetries: 0 },
        }),
        getDocumentData: builder.query({
            query: (data) => ({
                url: `/getDocumentData`,
                method: "GET",
                headers: {
                    "externalRequestId": data
                }
            }),
            extraOptions: { maxRetries: 0 },
        })
    })
});

export const {
    useSaveRemediationFilesMutation, useValidateDocumentMutation, useConsultDocumentsMutation,useGetReviewCurrentStatusMutation,
    useDnioptimizationMutation, useRutoptimizationMutation, useGetDocumentDataQuery
} = docReview;